import { filterHandler } from './filter';
import { closeModal, modalHandler } from './modal';
import { dropdownHandler, addDataToDropdown } from './dropdown';
import { searchableDropdownHandler } from './searchableDropdown';
import { inputHandler } from './input';
import { isJsonString, queryBuilder, isMobileScreen } from './utils';
import { BREAKPOINTS } from './constants';

const fetchItems = async(page, body, parent) => {
  const shoppingNetwork = document.getElementById('shopping-network');
  const pageKey = shoppingNetwork.getAttribute('data-page-key');
  const pageSize = shoppingNetwork.getAttribute('data-page-size');
  const filterUrl = shoppingNetwork.getAttribute('data-filter-url');
  const params = new URLSearchParams({
    pageKey: pageKey,
    numberOfItemsPerPage: pageSize,
    searchTerm: body['shopping-search-input'],
    page: page,
    category: body.category,
    type: body.type,
  });
  try {
    const response = await fetch(filterUrl + '?' + params.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const htmlContent = await response.text();
    parent.innerHTML = htmlContent;
  } catch (error) {
    console.error(error);
  }
};

const onFilter = (body, shoppingCards, page) => {
  queryBuilder(body);
  fetchItems(page, body, shoppingCards);
};

const updateModalFields = (data, fields) => {
  if (!isJsonString(data)) return;
  const parsedData = JSON.parse(data);
  const key = Object.keys(parsedData)[0];
  const values = parsedData[key];

  Array.from(fields)?.forEach((item) => {
    if (!item?.id) return;

    const linkProps = values?.CallToActionLink;
    const linkSecondaryProps = values?.CallToActionLinkSecondary;

    switch (item.id) {
    case 'shopping-network-name':
      item.textContent = values?.Name;
      break;
    case 'shopping-network-address':
      item.textContent = values?.Address;
      break;
    case 'shopping-network-phone':
      item.textContent = values?.Phone;
      break;
    case 'shopping-network-hours':
      item.textContent = values?.OperatingHours;
      break;
    case 'shopping-network-cta':
      if (!linkProps?.Name) return;
      item.textContent = linkProps?.Name;
      item.setAttribute('target', linkProps?.Target);
      item.setAttribute('href', linkProps?.Url);
      item.setAttribute('type', linkProps?.Type);
      item.classList.remove('hidden');
      break;
    case 'shopping-network-secondary-cta':
      if (!linkSecondaryProps?.Name) return;
      item.textContent = linkSecondaryProps?.Name;
      item.setAttribute('target', linkSecondaryProps?.Target);
      item.setAttribute('href', linkSecondaryProps?.Url);
      item.setAttribute('type', linkSecondaryProps?.Type);
      item.classList.remove('hidden');
      break;
    default:
      break;
    }
  });
};

const resetModalFields = (fields) => {
  Array.from(fields)?.forEach((item) => {
    if (!item?.id) return;

    switch (item.id) {
    case 'shopping-network-name':
      item.textContent = '';
      break;
    case 'shopping-network-address':
      item.textContent = '';
      break;
    case 'shopping-network-phone':
      item.textContent = '';
      break;
    case 'shopping-network-hours':
      item.textContent = '';
      break;
    case 'shopping-network-cta':
      item.textContent = '';
      item.setAttribute('target', '');
      item.setAttribute('href', '');
      item.setAttribute('type', '');
      item.classList.add('hidden');
      break;
    case 'shopping-network-secondary-cta':
      item.textContent = '';
      item.setAttribute('target', '');
      item.setAttribute('href', '');
      item.setAttribute('type', '');
      item.classList.add('hidden');
      break;
    default:
      break;
    }
  });
};

const updateSearchList = (data, list) => {
  let listHtml = '';
  data?.forEach(
    (item) =>
      (listHtml += `<li data-value='${JSON.stringify(
        item,
      )}'><button><p>${Object.keys(item)}</p></button></li>`),
  );
  list.innerHTML = listHtml;
};

const filterDataByProvince = (stores, province) => {
  const provinceId = Object.values(province)?.[0]?.Id;
  if (!provinceId) return stores;
  return stores?.filter((store) => Object.values(store)?.[0]?.ProvinceId === provinceId);
};

const formatDropdownData = (data) => JSON.parse(data)?.map((item) => ({
  [item.Name]: item,
}));

const removeListeners = (modal) => {
  const oldListeners = isMobileScreen(BREAKPOINTS.LG) ? modal.querySelectorAll('#shopping-network-map-mb-dropdown, [data-searchable-dropdown]')
    : modal.querySelectorAll('#shopping-network-map-dropdown, .shopping-network_modal_locations_list, [data-input-field] ');

  Array.from(oldListeners).forEach((item) => {
    const newElement = item.cloneNode(true);
    item.parentNode.replaceChild(newElement, item);
  });
};

const handleMobileModal = (modal, formatedProvincesData, formatedStoresData, fields) => {
  removeListeners(modal);
  const provinceDropdown = modal.querySelector('#shopping-network-map-mb-dropdown');
  addDataToDropdown(provinceDropdown, formatedProvincesData, { value: '', text: 'All' });
  const searchableDropdown = modal.querySelector('[data-searchable-dropdown]');

  dropdownHandler(provinceDropdown, (data) => {

    if (!isJsonString(data)) {
      addDataToDropdown(searchableDropdown, formatedStoresData);
      return;
    }
    const parsedData = JSON.parse(data);
    const filteredData = filterDataByProvince(formatedStoresData, parsedData);

    if (!filteredData) return;
    addDataToDropdown(searchableDropdown, filteredData);
  });

  searchableDropdownHandler(searchableDropdown, (value) => updateModalFields(value, fields));

};

const generateModalData = (stores, provinces, modal) => {
  if (!stores || !isJsonString(stores) || !modal || !isJsonString(provinces)) return;

  const fields = modal.querySelectorAll(
    '#shopping-network-name,#shopping-network-address, #shopping-network-phone,#shopping-network-hours,#shopping-network-cta,#shopping-network-secondary-cta'
  );

  const formatedProvincesData = formatDropdownData(provinces);
  const formatedStoresData = formatDropdownData(stores);

  if (isMobileScreen(BREAKPOINTS.LG)) return handleMobileModal(modal, formatedProvincesData, formatedStoresData, fields);

  removeListeners(modal);
  const provinceDropdown = modal.querySelector('#shopping-network-map-dropdown');
  const list = modal.querySelector('.shopping-network_modal_locations_list');
  const input = modal.querySelector('[data-input-field]');

  addDataToDropdown(provinceDropdown, formatedProvincesData, { value: '', text: 'All' });

  let filteredData = [];
  dropdownHandler(provinceDropdown, (data) => {
    if (!isJsonString(data)) {
      filteredData = filterDataByProvince(formatedStoresData, {});
      return updateSearchList(filteredData, list);
    }
    const parsedData = JSON.parse(data);
    filteredData = filterDataByProvince(formatedStoresData, parsedData);
    updateSearchList(filteredData, list);
  });

  let listData = [];
  inputHandler(input, (value) => {
    if (value) listData = filteredData?.filter((store) => Object.values(store)?.[0]?.Name?.toUpperCase()?.includes(value?.toUpperCase()));
    else listData = filteredData;
    updateSearchList(listData, list);
  });

  updateModalFields(list?.children?.[0]?.getAttribute('data-value'), fields);

  list.addEventListener('click', (e) => {

    const liTag = e.target.closest('li');

    if (liTag?.hasAttribute('data-value')) {
      updateModalFields(liTag?.getAttribute('data-value'), fields);
    }
  });
};

const showModal = (el, modal, body, shoppingCards) => {
  const tagName = el.tagName;

  if (tagName === 'BUTTON' && el?.hasAttribute('data-load-more')) {
    const nextPage = el?.getAttribute('data-next-page');
    el.classList.add('button--progress');
    onFilter(body, shoppingCards, nextPage);
    return;
  }

  if (!el.hasAttribute('data-load-more') && (tagName === 'BUTTON' || tagName === 'IMG')) {
    const stores = tagName === 'IMG' ? el.closest('button')?.getAttribute('data-card') : el.getAttribute('data-card');
    const provinces = tagName === 'IMG' ? el.closest('button')?.getAttribute('data-provinces') : el.getAttribute('data-provinces');
    generateModalData(stores, provinces, modal);
    if (!stores || stores === '[]') return;
    modal.showModal();
    modalHandler(modal);
    window.scrollTo(0, 0);
    return;
  }
};

const onShoppingNetworkLoad = () => {
  const shoopingNetwork = document.getElementById('shopping-network');

  if (!shoopingNetwork) return;
  const shoopingCards = shoopingNetwork.querySelector('[data-shopping-cards]');
  const shoopingFilter = shoopingNetwork.querySelector('[data-filter]');
  const modal = document.querySelector('[data-modal]');

  let body = {};
  filterHandler(shoopingFilter, (data) => {
    body = data;
    onFilter(body, shoopingCards, 1);
  });

  shoopingCards?.addEventListener('click', (e) =>
    showModal(e.target, modal, body, shoopingCards),
  );

  const onModalClose = () => {
    const fields = modal.querySelectorAll(
      '#shopping-network-name,#shopping-network-address, #shopping-network-phone,#shopping-network-hours,#shopping-network-cta,#shopping-network-secondary-cta'
    );
    resetModalFields(fields);
  };

  modal?.addEventListener('click', (e) => {
    closeModal(e, modal, onModalClose);
  });
};

export default onShoppingNetworkLoad;
